import { render, staticRenderFns } from "./PlatformEsView.vue?vue&type=template&id=0f7ff195&scoped=true&"
import script from "./PlatformEsView.vue?vue&type=script&lang=js&"
export * from "./PlatformEsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ff195",
  null
  
)

export default component.exports